var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_209_12662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20.0001 15.5228 20.0001 9.99996C20.0001 4.4771 15.5228 0 10 0C4.47724 0 0 4.47717 0 10C0 15.5229 4.47717 20 10 20ZM10 1.59998C14.6316 1.59998 18.4 5.36835 18.4 9.99996C18.4 14.6316 14.6316 18.3999 10 18.3999C5.36843 18.3999 1.60006 14.6316 1.60006 9.99996C1.60006 5.36835 5.36799 1.59998 10 1.59998Z",
    fill: "#010002"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14163 14.7168C8.694 14.7168 9.14165 14.2692 9.14165 13.7168V6.11679C9.14165 5.56441 8.69408 5.11676 8.14163 5.11676C7.58925 5.11676 7.1416 5.56434 7.1416 6.11679V13.7168C7.1416 14.2692 7.58918 14.7168 8.14163 14.7168Z",
    fill: "#010002"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1416 14.7168C12.694 14.7168 13.1416 14.2692 13.1416 13.7168V6.11679C13.1416 5.56441 12.694 5.11676 12.1416 5.11676C11.5891 5.11676 11.1416 5.56441 11.1416 6.11679V13.7168C11.1416 14.2692 11.5892 14.7168 12.1416 14.7168Z",
    fill: "#010002"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_209_12662"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPause);
export default __webpack_public_path__ + "static/media/icon-pause.000d2f99a089aafdeff110db2da2b0ef.svg";
export { ForwardRef as ReactComponent };